module.exports = __webpack_public_path__ + "img/VetoSans-Medium_1.6dd09509.svg";